<template>
  <el-row class="operation">
    <el-col :span="12">
      <span class="line">
        操作人：
        <span>{{ row.updateBy || row.createBy }}</span>
      </span>
    </el-col>
    <el-col :span="12">
      <span class="line">
        操作时间：
        <span>{{ parseTime(row.updateTime || row.createTime, '{y}-{m}-{d} {h}:{i}') }}</span>
      </span>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'box',
  props: {
    row: {
      type: [Array, Object],
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.operation {
  // border-top: 1px solid #dddddd;
  color: #a19797;
  padding: 20px 0 0;
}
</style>